export default __webpack_public_path__ + "static/media/akali_card.3fd21a83.png";